export const confluenceSteps = () => [
  {
    target: '[data-tour="space-sidebar"]',
    title: 'All Spaces',
    content:
      'Browse all available spaces. Each space contains documentation, meeting notes, and project knowledge for your team.',
    disableBeacon: true,
  },
  {
    target: '[data-tour="space-templates"]',
    title: 'Templates',
    content:
      'Use pre-built templates to quickly create pages for meeting notes, project plans, technical documentation, requirements, and more.',
  },
  {
    target: '[data-tour="create-space-btn"]',
    title: 'Create Space',
    content:
      'Create a new workspace to organize documentation, collaborate with your team, and manage knowledge efficiently.',
  },
  {
    target: '[data-tour="space-search"]',
    title: 'Search Spaces',
    content:
      'Search for spaces by name or keyword to quickly locate the information you need.',
  },
  {
    target: '[data-tour="space-filters"]',
    title: 'Filter Spaces',
    content:
      'Filter spaces by category and status to narrow down your results.',
  },
  {
    target: '[data-tour="space-table"]',
    title: 'Space Directory',
    content:
      'View all available spaces along with their key, description, and available actions.',
  },
];